import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function RouteAccessibility() {
  const { pathname } = useLocation();
  const previous = useRef({ pathname, title: "" });
  useEffect(() => {
    const update = () => {
      const heading = document.querySelector<HTMLElement>("main h1");
      const title = heading?.textContent?.trim();
      if (!heading || !title) return;
      const navigated =
        previous.current.pathname !== pathname ||
        (previous.current.title !== "" && previous.current.title !== title);
      previous.current = { pathname, title };
      document.title = `${title} | NOA Retraite`;
      if (navigated && !document.querySelector('[role="dialog"]')) {
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      }
    };
    const observer = new MutationObserver(update);
    observer.observe(document.getElementById("root")!, { childList: true, subtree: true });
    update();
    return () => observer.disconnect();
  }, [pathname]);
  return (
    <a
      href="#main-content"
      lang="fr"
      className="focus-ring sr-only fixed left-3 top-3 z-[100] rounded-lg bg-bg px-4 py-3 font-semibold text-ink focus:not-sr-only"
      onClick={() => document.getElementById("main-content")?.focus()}
    >
      Aller au contenu principal
    </a>
  );
}
